import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Group 7022" }, /* @__PURE__ */ React.createElement("rect", { id: "Rectangle 2238", x: 1, y: 1, width: 8, height: 8, stroke: "#1B4F2F", strokeWidth: 2, strokeLinejoin: "bevel" }), /* @__PURE__ */ React.createElement("rect", { id: "Rectangle 2237", opacity: 0.9, x: 2, y: 2, width: 6, height: 6, fill: "#13A813" })));
const ForwardRef = forwardRef(SvgNotificationDefault);
export { ForwardRef as ReactComponent };
